var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14C5.75 15.5188 6.98122 16.75 8.5 16.75C10.0188 16.75 11.25 15.5188 11.25 14C11.25 12.4812 10.0188 11.25 8.5 11.25C6.98122 11.25 5.75 12.4812 5.75 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3642 3.65563C15.7263 3.45447 15.8568 2.99787 15.6556 2.63578C15.4545 2.27369 14.9979 2.14324 14.6358 2.3444L6.25565 7.00001H4C2.89543 7.00001 2 7.89545 2 9.00001V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9.00001C22 7.89545 21.1046 7.00001 20 7.00001H9.34434L15.3642 3.65563ZM15 13.25H19C19.4142 13.25 19.75 13.5858 19.75 14C19.75 14.4142 19.4142 14.75 19 14.75H15C14.5858 14.75 14.25 14.4142 14.25 14C14.25 13.5858 14.5858 13.25 15 13.25ZM14.25 11C14.25 10.5858 14.5858 10.25 15 10.25H19C19.4142 10.25 19.75 10.5858 19.75 11C19.75 11.4142 19.4142 11.75 19 11.75H15C14.5858 11.75 14.25 11.4142 14.25 11ZM15 16.25H19C19.4142 16.25 19.75 16.5858 19.75 17C19.75 17.4142 19.4142 17.75 19 17.75H15C14.5858 17.75 14.25 17.4142 14.25 17C14.25 16.5858 14.5858 16.25 15 16.25ZM8.5 18.25C6.15279 18.25 4.25 16.3472 4.25 14C4.25 11.6528 6.15279 9.75001 8.5 9.75001C10.8472 9.75001 12.75 11.6528 12.75 14C12.75 16.3472 10.8472 18.25 8.5 18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.5eb26ff015766b544a4259fea34c82e5.svg";
export { ForwardRef as ReactComponent };